module.exports = __webpack_public_path__ + "static/4iiii3-dc0815f888e06a8cc7f7db9fda1addc1.jpg";